const CURRENT_YEAR = new Date().getFullYear();

const FOOTER_COLS = [
  {
    title: "Product",
    links: [
      { label: "Features",          href: "#features"     },
      { label: "Performance",       href: "#performance"  },
      { label: "Compare",           href: "#compare"      },
      { label: "Pricing",           href: "#pricing"      },
      { label: "Changelog",         href: "#"             },
    ],
  },
  {
    title: "Players",
    links: [
      { label: "Web / PWA",         href: "#players" },
      { label: "Electron",          href: "#players" },
      { label: "Tauri",             href: "#players" },
      { label: "Android TV",        href: "#players" },
      { label: "Raspberry Pi",      href: "#players" },
    ],
  },
  {
    title: "Resources",
    links: [
      { label: "Documentation",     href: "#docs"    },
      { label: "Architecture docs", href: "#docs"    },
      { label: "KSP protocol",      href: "#docs"    },
      { label: "GitHub",            href: "#"        },
      { label: "Discord",           href: "#"        },
    ],
  },
  {
    title: "Company",
    links: [
      { label: "About",             href: "#"        },
      { label: "Blog",              href: "#"        },
      { label: "QuantumOS X3",      href: "#"        },
      { label: "Contact",           href: "#"        },
      { label: "Status",            href: "#"        },
    ],
  },
] as const;

export function Footer() {
  return (
    <footer className="footer" aria-label="Site footer">
      <div className="container">
        <div className="footer-grid">
          {/* Brand column */}
          <div>
            <a href="#" className="nav-logo" aria-label="Kynetra Signage home" style={{ display: "inline-flex", textDecoration: "none" }}>
              <span className="nav-logo-mark" style={{
                background: "linear-gradient(135deg, #5b7cf6 0%, #9b6bf5 50%, #c471ed 100%)",
                borderRadius: 8,
                width: 32,
                height: 32,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: 15,
                fontWeight: 900,
                color: "#fff",
              }} aria-hidden="true">K</span>
              <span className="nav-logo-text" style={{ fontSize: 17, fontWeight: 800, color: "var(--text-primary)", letterSpacing: "-0.3px", marginLeft: 10 }}>Kynetra</span>
            </a>
            <p className="footer-brand-desc">
              Open, cross-platform digital signage. One engine for every screen.
              Built on Cloudflare edge. AGPL-3.0.
            </p>
            <div style={{ display: "flex", gap: 10 }}>
              <a
                href="#"
                aria-label="Kynetra GitHub repository"
                style={{ color: "var(--text-muted)", transition: "color 0.15s" }}
                onMouseEnter={(e) => (e.currentTarget.style.color = "var(--text-secondary)")}
                onMouseLeave={(e) => (e.currentTarget.style.color = "var(--text-muted)")}
              >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                  <path d="M9 19c-5 1.5-5-2.5-7-3m14 6v-3.87a3.37 3.37 0 0 0-.94-2.61c3.14-.35 6.44-1.54 6.44-7A5.44 5.44 0 0 0 20 4.77 5.07 5.07 0 0 0 19.91 1S18.73.65 16 2.48a13.38 13.38 0 0 0-7 0C6.27.65 5.09 1 5.09 1A5.07 5.07 0 0 0 5 4.77a5.44 5.44 0 0 0-1.5 3.78c0 5.42 3.3 6.61 6.44 7A3.37 3.37 0 0 0 9 18.13V22" />
                </svg>
              </a>
            </div>
          </div>

          {/* Link columns */}
          {FOOTER_COLS.map(({ title, links }) => (
            <div key={title}>
              <p className="footer-col-title">{title}</p>
              <ul className="footer-links" role="list">
                {links.map(({ label, href }) => (
                  <li key={label}>
                    <a href={href}>{label}</a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom bar */}
        <div className="footer-bottom">
          <p className="footer-copyright">
            © {CURRENT_YEAR} Kynetra. Open-source · AGPL-3.0-or-later.
          </p>
          <nav className="footer-legal" aria-label="Legal links">
            <a href="#">Privacy</a>
            <a href="#">Terms</a>
            <a href="#">License</a>
          </nav>
        </div>
      </div>
    </footer>
  );
}
